import type {
  FeatureServiceBinder,
  FeatureServiceProviderDefinition,
  SharedFeatureService,
} from '@feature-hub/core';

export interface CartUpdateServiceV1 {
  readonly publish: () => void;

  readonly subscribe: (
    listener: () => void,
    options?: {readonly signal?: AbortSignal},
  ) => () => void;
}

export interface SharedCartUpdateService extends SharedFeatureService {
  readonly '1.0.0': FeatureServiceBinder<CartUpdateServiceV1>;
}

export const cartUpdateServiceDefinition: FeatureServiceProviderDefinition<SharedCartUpdateService> =
  {
    id: `cart-update-service`,

    create: () => {
      const listeners = new Set<() => void>();

      return {
        '1.0.0': () => ({
          featureService: {
            publish: () => {
              for (const listener of listeners) {
                listener();
              }
            },

            subscribe: (listener, options = {}) => {
              listeners.add(listener);

              const unsubscribe = () => listeners.delete(listener);

              options.signal?.addEventListener(`abort`, unsubscribe);

              return unsubscribe;
            },
          },
        }),
      };
    },
  };
